var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.969,5.027a.643.643,0,0,0-.549-.458L7.956,4.241,6.587.9A.628.628,0,0,0,5.414.9L4.044,4.241.58,4.569a.644.644,0,0,0-.549.458.684.684,0,0,0,.186.707l2.618,2.4-.772,3.549a.68.68,0,0,0,.248.687.612.612,0,0,0,.7.032L6,10.534,8.987,12.4a.613.613,0,0,0,.7-.032.681.681,0,0,0,.248-.687L9.164,8.13l2.618-2.4A.685.685,0,0,0,11.969,5.027Zm0,0",
    transform: "translate(0 -0.492)",
    fill: "#dbdbe6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyStar);
export default __webpack_public_path__ + "static/media/grey-star.24015f6684e4e921bccf865d4e79be63.svg";
export { ForwardRef as ReactComponent };